export const LogoContainer = (logo: string) => (`
  <div class="logo-container--wrapper">
    <img style="width:130px;" src="${logo}" alt="logo" />
  </div>
`);